// Parses CSV text into an array of rows, each an array of cell strings.
// Handles quoted cells, escaped quotes ("") and CRLF line endings.
const parseCsv = text => {
    const rows = [];
    let row = [];
    let cell = '';
    let inQuotes = false;
    const input = text.replace(/^﻿/, '');

    for (let i = 0; i < input.length; i++) {
        const char = input[i];

        if (inQuotes) {
            if (char === '"' && input[i + 1] === '"') {
                cell += '"';
                i++;
            } else if (char === '"') {
                inQuotes = false;
            } else {
                cell += char;
            }
        } else if (char === '"') {
            inQuotes = true;
        } else if (char === ',') {
            row.push(cell);
            cell = '';
        } else if (char === '\n' || char === '\r') {
            if (char === '\r' && input[i + 1] === '\n') i++;
            row.push(cell);
            rows.push(row);
            row = [];
            cell = '';
        } else {
            cell += char;
        }
    }

    if (cell || row.length) {
        row.push(cell);
        rows.push(row);
    }

    return rows;
};

export default parseCsv;
